export const BankIDTextKeys = [
	'BANKID_NETWORK_ERROR',
	'BANKID_GENERAL_ERROR',
	'BANKID_AUTH_ERROR',
	'BANKID_INVALID_PLAYER_STATUS',
	'BANKID_BL_LOGIN_OR_REGISTER',
	'BANKID_BL_VERIFY_PERSONAL_ID',
	'BANKID_BL_EMAIL_PHONE_ERROR_VERIFICATION',
	'BANKID_BL_PLAYER_NOT_FOUND',
	'BANKID_EMAIL_EXISTS',
	'BANKID_BL_COULD_NOT_SET_EMAIL',
	'BANKID_ACCOUNT_LINK_SUCCESS',
	'BANKID_ACCOUNT_LINK_ERROR',
	'BANKID_INVALID_PLAYER_AGE',
	'BANKID_INVALID_PERSONAL_NUMBER',
	'BANKID_REQ_ALREADY_IN_PROGRESS',
	'BANKID_CHECK_BANKID_DEVICE',
	'BANKID_SPELPAUS_EXCLUDED_ON_REGISTRATION',
	'BANKID_SPELPAUS_EXCLUDED_ON_LOGIN',
	'BANKID_PLAYER_ALREADY_EXISTS',
	'BANKID_ACC_LOCKED',
	'BANKID_EXCEPTION_CLOSED_ACCOUNT',
	'BANKID_ACC_LOCKED_REOPEN',
	'BANKID_PERSONAL_NUMBER_BLACKLISTED',
	'BANKID_ORDER_REF_CANNOT_BE_EMPTY',
	'BANKID_SPELPAUS_COMMUNICATION_ERROR',
	'BANKID_SUSPEND_TIME_ACCOUNT',
	'BANKID_SGA_PLAYER_HIDDEN_DATA',
	'BANKID_PLAYER_EXCEPTION_MOBILE_EXIST',
	'BANKID_USERSESSION_NOT_FOUND',
	'VALIDATION_ERROR_EMAIL'
];

export const BankIDFormTextKeys = [
	'BANKID_CHECK_BANKID_DEVICE',
	'BUTTON_CANCEL',
	'MOBILE_AGE_VERIFICATION_AND_TERMS_AND_CONDITIONS',
	'MOBILE_LINK_TO_TERMS_AND_CONDITIONS',
	'MOBILE_LINK_PRIVACY_POLICY',
	'AND',
	'PERSONAL_ID',
	'BANKID_PERSONAL_NUMBER_PLACEHOLDER',
	'BANKID_PERSONAL_NUMBER_TITLE',
	'BANKID_INVALID_PERSONAL_NUMBER',
	'BANKID_UNDERAGE_PERSONAL_NUMBER',
	'BANKID_GET_STARTED',
	'BANKID_PLAY_NOW_DESCRIPTION',
	'CONTINUE',
	'QR_CODE',
	'INSTRUCTION_START_BANKID_APP',
	'INSTRUCTION_CLICK_SCAN',
	'INSTRUCTION_SCAN_QRCODE',
	'QRCODE_ERROR_TITLE',
	'QRCODE_ERROR_FAILED',
	'QRCODE_ERROR_SERVER',
	'MOBILE_RESULT_FAIL_TRY_AGAIN_BUTTON',
	'BANKID_OPEN_SAME_DEVICE'
];
